/**
 * DART 주석 레퍼런스 검색 - 표를 붙여넣으면 유사한 DART 주석 표를 찾는다.
 * 메뉴에는 없고 `/reference-search` 링크로만 들어오는 전체화면 페이지다(사이드바 없음).
 */

import type { ReferenceTableHit } from "@/apis/reference-search/types";
import { useState } from "react";
import { QueryTableInput } from "./query-table-input";
import { HitList } from "./hit-list";

export const ReferenceSearchPage = () => {
  const [hits, setHits] = useState<ReferenceTableHit[] | null>(null);
  const [elapsedMs, setElapsedMs] = useState<number | null>(null);
  // XBRL 매핑 있는 표만. 기본 켬(2026-09-29 결정 c) — 끄면 1,374건 전체가 대상이다.
  const [mappedOnly, setMappedOnly] = useState(true);

  return (
    <div className="flex h-screen w-full bg-white">
      {/* 스크롤은 전체 폭의 main 이 맡고, 폭 상한·가운데 정렬은 안쪽 래퍼가 맡는다
          — 상한을 스크롤 컨테이너에 걸면 좌우 여백에서 휠이 안 먹는다. */}
      <main className="min-w-0 flex-1 overflow-y-auto">
        <div className="mx-auto flex max-w-[1440px] flex-col gap-6 p-8">
          <div className="flex flex-col gap-1">
            <h1 className="title-2-bold text-label-normal">
              주석 레퍼런스 검색
            </h1>
            <p className="body-1-normal-medium text-label-neutral">
              표를 붙여넣으면 다른 회사가 공시한 비슷한 주석 표를 찾아줍니다.
              숫자는 보지 않고 행 라벨·열 헤더·제목으로 비교합니다.
            </p>
          </div>
          <div className="grid min-w-0 grid-cols-1 gap-6 xl:grid-cols-[380px_minmax(0,1fr)]">
            <QueryTableInput
              mappedOnly={mappedOnly}
              onResult={(result, ms) => {
                setHits(result);
                setElapsedMs(ms);
              }}
            />
            <HitList
              hits={hits}
              elapsedMs={elapsedMs}
              mappedOnly={mappedOnly}
              onMappedOnlyChange={setMappedOnly}
            />
          </div>
        </div>
      </main>
    </div>
  );
};
